<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>Galeri</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Foto
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="onSubmit">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="dropzone">Foto</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <vue-dropzone @vdropzone-success="vsuccess" @vdropzone-file-added="vfileAdded" :destroyDropzone="false" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-removed-file="vremoved"></vue-dropzone>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Video
                            </h2>
                            <ul class="header-dropdown m-r--5 m-t--10">
                                <router-link v-bind:to="'/main/informasi/galeri/tambah'" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                    <i class="material-icons" style="color: #fff;">add_box</i>
                                    <span>Tambah</span>
                                </router-link>
                            </ul>
                        </div>
                        <div class="body">
                            <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                                <div class="row"><div class="col-sm-6"><div class="dataTables_length" id="DataTables_Table_0_length"><label>Show <select name="DataTables_Table_0_length" v-model="perPage" aria-controls="DataTables_Table_0" class="form-control input-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select> entries</label></div></div><div class="col-sm-6"><div id="DataTables_Table_0_filter" class="dataTables_filter"><label>Search:<input v-model="search" type="search" class="form-control input-sm" placeholder="" aria-controls="DataTables_Table_0"></label></div></div></div>
                                <table class="table table-bordered table-striped table-hover js-basic-example dataTable">
                                    <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Thumb</th>
                                        <th>Link</th>
                                        <th>Deskripsi</th>
                                        <th>Aksi</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="isLoading">
                                        <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner"></i> Loading data...</td>
                                    </tr>
                                    <tr v-if="list == ''">
                                        <td colspan="5" class="text-center">Data tidak ditemukan</td>
                                    </tr>
                                    <tr v-if="!isLoading" v-for="(item, index) in list">
                                        <td>{{ ++index + ((currentPage-1)*perPage) }}</td>
                                        <td><iframe style="border: 0; width: 300px; heigh: 250px" v-bind:src="item.file"></iframe></td>
                                        <td>{{ item.file }}</td>
                                        <td>{{ item.deskripsi }}</td>
                                        <td>
                                            <button @click="$router.push('/main/informasi/galeri/edit/' + item.id_galeri)" style="padding: 4px 8px;" type="button" class="btn bg-green waves-effect">
                                                <i class="material-icons">create</i>
                                            </button>
                                            <button @click="confirmDelete(item.id_galeri)" style="padding: 4px 8px;" type="button" class="btn btn-danger waves-effect">
                                                <i class="material-icons">delete</i>
                                            </button>

                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <pagination :total-rows="result.totalElements" :per-page="result.size" v-model="currentPage"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  export default {
    components: {FormLine, Ckeditor, vueDropzone: vue2Dropzone},
    name: 'ListNarasumber',
    data: function () {
      return {
        dropzoneOptions: {
          url: api.defaults.baseURL + '/upload_galeri',
          thumbnailWidth: 150,
          addRemoveLinks: true,
          maxFilesize: 200,
          dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('_token') },
          previewTemplate: this.template()
        },
        galeri: [],
        result: {},
        list: [],
        currentPage: 1,
        perPage: 10,
        search: '',
        isLoading: true
      }
    },
    methods: {
      template () {
        return '<div class="dz-preview dz-file-preview">' +
          '<div class="dz-image" style="width: 200px;height: 200px">' +
          '<img data-dz-thumbnail />' +
          '</div>' +
          '<div class="dz-details">' +
          '<div class="dz-size"><span data-dz-size></span></div>' +
          '<div class="dz-filename"><span data-dz-name></span></div>' +
          '<div class="dz-extra">' +
          '<a class="dz-remove dz-add-desc" href="javascript:undefined;" data-dz-description">Add description</a>' +
          '</div>' +
          '</div> ' +
          '<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
          '<div class="dz-error-message"><span data-dz-errormessage></span></div>' +
          '<div class="dz-success-mark"><i class="fa fa-check"></i></div>' +
          '<div class="dz-error-mark"><i class="fa fa-close"></i></div>' +
          '</div> ' +
          '<div class="">' +
          '<select class="form-control" title="" name="image_type">' +
          '<options v-for="type in image_type" value="type.value">{{ type.title }}</options>' +
          '</select>' +
          '</div>'
      },
      addDescription (file) {
        console.log(file)
      },
      vsuccess (file, response) {
        let id = response.object.id_galeri
        let deskripsi = response.object.deskripsi
        file.previewElement.querySelector('.dz-add-desc').setAttribute('data-dz-id', id)
        file.previewElement.querySelector('.dz-add-desc').setAttribute('data-dz-desc', deskripsi)
      },
      vfileAdded (file) {
        let _self = this
        file.previewElement.querySelector('.dz-add-desc').setAttribute('data-dz-id', file.id)
        file.previewElement.querySelector('.dz-add-desc').setAttribute('data-dz-desc', file.deskripsi)
        file.previewElement.querySelector('.dz-add-desc').addEventListener('click', function () {
          let id = this.getAttribute('data-dz-id')
          let desc = this.getAttribute('data-dz-desc')
          if (desc === 'null') desc = ''

          _self.$swal('Edit description', {
            content: {
              element: 'input',
              attributes: {
                value: desc,
                placeholder: 'Masukkan deskripsi disini'
              }
            }
          }).then(result => {
            if (result) {
              let data = {
                deskripsi: result
              }
              api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
              api.post('/galeri/' + id, data).then((result) => {
                _self.$toastr.s('Deskripsi berhasil diubah')
                _self.getDetail()
              }).catch((ex) => {
                _self.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
              })
            }
          })
        })
      },
      getData () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/galeri').then((result) => {
          this.list = result.data.content
          this.isLoading = false
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
          this.isLoading = false
        })
      },
      getDetail () {
        this.init = true
        this.$refs.myVueDropzone.removeAllFiles()
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/galeri/all?tipe=1').then((result) => {
          this.galeri = result.data
          for (var i = 0; i < this.galeri.length; i++) {
            this.$refs.myVueDropzone.manuallyAddFile({ name: this.galeri[i].deskripsi, id: this.galeri[i].id_galeri, deskripsi: this.galeri[i].deskripsi, size: this.galeri[i].size }, this.galeri[i].file)
          }
          this.init = false
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
          this.init = false
        })

        this.getData()
      },
      vremoved (file, xhr, error) {
        if (!this.init) this.delete(file.id)
      },
      confirmDelete (id) {
        this.$swal({
          title: 'Konfirmasi',
          text: 'Anda yakin ingin menghapus data ini?',
          icon: 'warning',
          buttons: [
            true, {
              text: 'Ok',
              closeModal: false
            }
          ],
          dangerMode: true
        }).then(result => {
          if (result) {
            this.delete(id)
          }
        })
      },
      delete (id) {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.delete('/galeri/' + id).then((result) => {
          this.$toastr.s('Galeri berhasil dihapus')
          this.getData()
          this.$swal.close()
        }).catch(e => {
          this.getData()
          this.$swal.close()
        })
      }
    },
    mounted () {
      this.getDetail()
    },
    watch: {
      currentPage (e) {
        this.getData()
      },
      perPage (e) {
        this.getData()
      },
      search (e) {
        this.getData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Informasi/Galeri.vue?75af363e